import MetricActions from "../../actions/MetricActions";

function StatChip({ label, value }) {
  return (
    <div className="rounded-lg bg-muted/50 border border-border px-3 py-2.5">
      <p className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
        {label}
      </p>
      <p className="mt-0.5 text-sm font-semibold text-foreground truncate">
        {value}
      </p>
    </div>
  );
}

const MetricCard = ({ metrics, allMetrics }) => {
  const pageLoadTime =
    metrics.lcp && metrics.tbt
      ? `${(
          Number(metrics.lcp.value) +
          Number(metrics.tbt.value) / 1000
        ).toFixed(2)} s`
      : "N/A";

  const stats = [
    { label: "Page weight", value: metrics.totalRequestSize },
    { label: "Requests", value: metrics.numberOfRequests },
    { label: "Load time", value: pageLoadTime },
    { label: "TTFB", value: metrics.ttfb },
  ];

  return (
    <div className="px-4 pb-4 pt-2">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {stats.map((item) => (
          <StatChip key={item.label} label={item.label} value={item.value} />
        ))}
      </div>

      <div className="mt-6 pt-5 border-t border-border">
        <MetricActions metrics={metrics} allMetrics={allMetrics} />
      </div>
    </div>
  );
};

export default MetricCard;
